var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4 0c.308 0 .561.228.596.522L9 .591v.59h1.2a1.79 1.79 0 0 1 1.794 1.628l.006.146v8.272c0 .98-.806 1.773-1.8 1.773H1.8C.806 13 0 12.206 0 11.227V2.955c0-.98.806-1.773 1.8-1.773L3 1.18v-.59C3 .265 3.269 0 3.6 0c.308 0 .561.228.596.522L4.2.591v.59h3.6v-.59C7.8.265 8.069 0 8.4 0zm2.4 5.909H1.2v5.318c0 .294.218.538.503.583l.097.008h8.4c.331 0 .6-.264.6-.59V5.908zM3 2.363H1.8c-.331 0-.6.265-.6.592v1.772h9.6V2.955a.594.594 0 0 0-.503-.584l-.097-.007L9 2.363v.592c0 .326-.269.59-.6.59a.597.597 0 0 1-.596-.522L7.8 2.955v-.592H4.2v.592c0 .326-.269.59-.6.59a.597.597 0 0 1-.596-.522L3 2.955v-.592z",
    fill: "#587E85",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.89888097cc0c2583ae15bdf6723e3b0c.svg";
export { ForwardRef as ReactComponent };